import React, { useContext } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import bemCnFast from '@webteam/bem-cn-fast';
import { useTheme } from '@rescui/ui-contexts';
import localNames from '../index.pcss.js';
import { ListContextInner } from './list-context-inner.js';

var bemCn = bemCnFast('wt-list-group-header', localNames);
function GroupHeader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      text = _ref.text,
      _ref$size = _ref.size,
      propsSize = _ref$size === void 0 ? 'm' : _ref$size,
      propsTheme = _ref.theme;
  var theme = useTheme(propsTheme);

  var _useContext = useContext(ListContextInner),
      size = _useContext.size,
      contextTheme = _useContext.theme;

  return React.createElement("li", {
    className: cn(bemCn({
      size: size || propsSize,
      theme: contextTheme || theme
    }), className)
  }, text);
}
GroupHeader.propTypes = {
  size: PropTypes.oneOf(['m', 's', 'xs']),
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  text: PropTypes.string
};

export { GroupHeader };
